import Alert from '@mui/material/Alert';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { apiErrorMessageKey } from '../../../lib/api';

export function OnboardingStepError({ error }: { error: unknown }): ReactElement | null {
    const { t } = useTranslation();
    if (!error) {
        return null;
    }
    return <Alert severity="error">{t(apiErrorMessageKey(error, 'ONBOARDING.ERRORS.SAVE_FAILED'))}</Alert>;
}
